import NavigateBeforeIcon from "@mui/icons-material/NavigateBefore";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { Box, IconButton, Tooltip, Typography } from "@mui/material";
import { EditableValue } from "./EditableValue";

const iconBtnSx = {
  color: "#5C6B7A",
  "&:not(:disabled):hover": { color: "#002A5C" },
  "&.Mui-disabled": { color: "#C4CDD8" },
};

interface Props {
  selectedIdx: number | null;
  total: number;
  onPrev: () => void;
  onNext: () => void;
  /** Called with the raw 1-based index typed by the user. */
  onJump: (oneBasedIdx: number) => void;
}

export function KksNavigator({
  selectedIdx,
  total,
  onPrev,
  onNext,
  onJump,
}: Props) {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 0.5,
        bgcolor: "#EDF1F7",
        borderRadius: 2,
        px: 1,
      }}
    >
      <Tooltip title="Previous KKS (↑)">
        <span>
          <IconButton
            onClick={onPrev}
            disabled={selectedIdx === null || selectedIdx <= 0}
            size="small"
            sx={iconBtnSx}
          >
            <NavigateBeforeIcon fontSize="small" />
          </IconButton>
        </span>
      </Tooltip>
      {selectedIdx !== null ? (
        <>
          <Typography
            variant="caption"
            sx={{ color: "#5C6B7A", fontWeight: 500 }}
          >
            KKS
          </Typography>
          <EditableValue
            display={String(selectedIdx + 1)}
            initialDraft={String(selectedIdx + 1)}
            onCommit={(v) => {
              const n = parseInt(v);
              if (!isNaN(n)) onJump(n);
            }}
          />
          <Typography variant="caption" sx={{ color: "#8E99A8" }}>
            / {total}
          </Typography>
        </>
      ) : (
        <Typography variant="caption" sx={{ color: "#5C6B7A", px: 0.5 }}>
          {total} KKS
        </Typography>
      )}
      <Tooltip title="Next KKS (↓)">
        <span>
          <IconButton
            onClick={onNext}
            disabled={selectedIdx !== null && selectedIdx >= total - 1}
            size="small"
            sx={iconBtnSx}
          >
            <NavigateNextIcon fontSize="small" />
          </IconButton>
        </span>
      </Tooltip>
    </Box>
  );
}
